import { inject } from '@angular/core';
import { Router, RedirectCommand, CanActivateFn } from '@angular/router';

import { AuthSelectorsFacade } from '@ps/auth-data-access';
import { APP_ROUTES } from '@ps/core-config';

export const surveyWorkflowAccessGuard: CanActivateFn = () => {
  const facade = inject(AuthSelectorsFacade);
  const router = inject(Router);

  const userType = facade.userType();

  if (!['buyer', 'operator'].includes(userType)) {
    return new RedirectCommand(router.parseUrl(APP_ROUTES.NOT_FOUND));
  }

  const isOperatorWithoutImpersonation =
    userType === 'operator' && !facade.hasImpersonatedBuyer();

  if (isOperatorWithoutImpersonation) {
    return new RedirectCommand(router.parseUrl(APP_ROUTES.DASHBOARD));
  }

  return true;
};
